export const SMART_INSIGHTS_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/5d44574160f44536b0130abf58cb87cc/fde907b374c110148256ba36ed42f971.html?locale=en-US";

export const RDS_SETUP_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf13fc574c110148813e9861f7fecda.html?locale=en-US";

export const PLAN_RELAUNCH_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf0429b74c11014be6de7e4c8a231a2.html?locale=en-US";

export const DELETE_CONTACT_API_HELP_LINK =
  "https://dev.emarsys.com/docs/loyalty-api-v3/aeb9b068a70ec-delete-a-contact";

export const PLAN_FIRST_LAUNCH =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdee0ed374c11014ad4afe2080ddcf22.html?locale=en-US#:~:text=I%20want%20to%20launch%20my%20Loyalty%20plan%2C%20but%20the%20launch%20button%20is%20not%20clickable.%20What%20do%20I%20need%20to%20do%3F";

export const SALES_DATA_SHOPIFY_PLUGIN_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/5d44574160f44536b0130abf58cb87cc/fdefd3fd74c11014b8a0e6632f8bd054.html?locale=en-US#setting-up-flexible-sales-data-for-clients-using-the-sap-emarsys-shopify-or-adobe-commerce-plug-in";

export const SALES_DATA_CSV_API_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdea9d2f74c110149cf7b9d75a833aa9.html?locale=en-US#phase-2-integrating-smart-insight-sales-data-and-the-product-catalog";

export const SALES_DATA_ORIGINAL_PRICE_FIELD_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/5d44574160f44536b0130abf58cb87cc/fdf6fbc574c11014855de082fd7ded5b.html?locale=en-US#:~:text=to%20mix%20them.-,Loyalty%20fields,-If%20you%20are";

export const SALES_DATA_IMPORT_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf2329f74c1101481608aa154331995.html?locale=en-US#sales-data-import";

export const PRODUCT_CATALOG_IMPORT_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf2329f74c1101481608aa154331995.html?locale=en-US#product-catalog-import";

export const DATA_LOAD_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf2329f74c1101481608aa154331995.html?locale=en-US#data-load";

export const ACTIONS_OVERVIEW_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdea732074c11014b8198e35bb89e4bf.html?locale=en-US#overview";

export const ACTIONS_PURCHASE_SETUP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdea7de174c11014a398d588e04090fc.html?locale=en-US";

export const ACTIONS_PROMOTION_SETUP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdea82a574c11014b4ab87b7d9fc9306.html?locale=en-US";

export const ACTIONS_ENGAGEMENT_SETUP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdea872f74c11014848d907aa1ce4e55.html?locale=en-US";

export const ACTIONS_EVENT_SETUP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdea872f74c11014848d907aa1ce4e55.html?locale=en-US";

export const ACTIONS_REFERRAL_SETUP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdeef4f574c11014a278956df7fe0479.html?locale=en-US";

export const ACTIONS_JOIN_SETUP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdea787674c11014b9238c98c0d43d85.html?locale=en-US";

export const VOUCHERS_FOR_REWARD_SETUP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf04d1574c110148c2ad6efcb1fc80d.html?locale=en-US";

export const VOUCHERS_FOR_POINTS_SETUP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf0499e74c11014b4aad8915043df19.html?locale=en-US";

export const VOUCHERS_FOR_FREE_SETUP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf0509074c110148035f9f0f5652052.html?locale=en-US";

export const VOUCHERS_AS_CASHBACK_SETUP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf06cb674c11014966c9fb9bc8efa3f.html?locale=en-US";

export const EXCLUSIVE_ACCESS_SETUP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdeaf91d74c1101492d29990993b3311.html?locale=en-US";

export const TIERS_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdea6e9474c110149167bd09047e7743.html?locale=en-US";

export const FIXED_BENEFITS_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf0461874c11014a78287d856f71e82.html?locale=en-US";

export const ADDITIONAL_BENEFITS_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdef6e3c74c11014918ac3b1535c0f8c.html?locale=en-US";

export const INVITE_TIER_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdef110974c11014ac14e6b46512588e.html?locale=en-US";

export const ACCOUNT_SETTINGS_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdeaa18c74c1101491c08df6323426d9.html?locale=en-US";

export const LANGUAGE_AND_CURRENCY_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf081f774c1101497fc9c06ebaacabf.html?locale=en-US";

export const MARKETS_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdeb58a074c11014bd1fd7945de29b2a.html?locale=en-US";

export const PLAN_SETTING_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf081f774c1101497fc9c06ebaacabf.html?locale=en-US#plan-settings";

export const MEMBERSHIP_SETTINGS_HELP_LINK =
  "https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf081f774c1101497fc9c06ebaacabf.html?locale=en-US#defining-membership-settings";

export const PLAN_LAUNCH_HELP_LINK =
  " https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdf0429b74c11014be6de7e4c8a231a2.html?locale=en-US";
